import React from "react";
import PropTypes from "prop-types";

import BEM from "./HeaderTitle.module.scss";

export const HeaderTitle = ({ title, icon }) => {
  return (
    <h2 className={BEM.BLOCK}>
      {icon && (
        <span
          className={BEM.headerIcon}
          style={{ backgroundImage: `url(${icon})` }}
        ></span>
      )}
      <span className={BEM.headerText}>{title}</span>
    </h2>
  );
};

HeaderTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  icon: PropTypes.string,
};
